import React from 'react';
import styled from 'styled-components';
import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux'
import H1 from "../../Components/H1";
import {ToolbarWithLogo} from '../../Components/Toolbar';
import ContainerPage, {Routes} from "../ContainerPage";
import {
    removeMeetings,
    resetWizard,
    setServices,
    setExistingMeetingsGroupMode,
    changeItemQuantity,
    changeItemGender, selectServiceCategory
} from '../Welcome/Actions';
import {BottomWrapper, TopWrapper, SelectViewWrapper} from '../../Components/Layout';
import PoweredBy from "../../Components/PoweredBy";
import Select from "../../Components/Select";
import {SHEKEL_SIGN} from "../../Common/Helpers";
import ProgressTracker from "../../Components/ProgressTracker";
import Toast from "../../Components/Toast";
import ExistingMeetingPopOver from "../../Components/ExistingMeetingPopOver";
import NavigationButton from "../../Components/NavigationButton";
import {
    cleanObj,
    getSafely,
    isNonEmptyString,
    valueOrDefault
} from "@tomeravni/easybizy-js-common/common";
import {PROGRESS_KEY, SIMULTANEOUS_SERVICE_SCHEDULING_TYPE} from "../../Common/constants";
import SimultaneousServicesSchedulingTypePicker from "../../Components/SimultaneousServicesSchedulingTypePicker";
import PickGender from "../../Components/PickGender";
import Sizes from '../../Assets/Sizes';
import HorizontalCarousel from "../../Components/HorizontalCarousel";
import {Check} from "@material-ui/icons";


const SimultaneousServicesSchedulingType = styled.div`
    font-size: 95%;
    height: 30px;
    display: flex;
    flex-direction: column;
    justify-content: end;
`;

const CarouselWrapper = styled.div`
    padding: ${Sizes.mediumPadding} 0;
    width: 100%;
`

const SubscriptionWrapperCmp = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    column-gap: ${Sizes.smallMargin};
    margin-inline-end: ${Sizes.mediumPadding};
`

class PickServices extends ContainerPage {
    componentWillMount() {
        super.componentWillMount();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.config && nextProps.config.AllowPickingEmployees) {
            this.nextRoute = Routes.pickEmployee
        } else {
            this.nextRoute = Routes.pickTime;
        }
    }

    // Even if URL is incorrect, fix it.
    toggleService(item) {
        const pickMultipleServices = this.props.config.PickMultipleServices;
        if (!pickMultipleServices) {
            if (this.isItemSelected(item)) {
                return this.props.setServices([]);
            }

            this.props.setServices([item]);
            const shouldAutoProgress = !(item.PickGenderCount > 0 || item.EnabledSimultaneousServicesCount > 1);
            if (shouldAutoProgress) {
                return this.next();
            } else {
                return;
            }
        }

        const updatedServices = (this.props.services && this.props.services.asMutable()) || [];
        let currentIndex = -1;
        for (let idx in updatedServices) {
            if (updatedServices[idx].OnlineBookingServiceId === item.OnlineBookingServiceId) {
                currentIndex = idx;
                break;
            }
        }

        let clearQuantity = false;
        if (currentIndex > -1) {
            updatedServices.splice(currentIndex, 1);
            clearQuantity = this.resolveItemQuantity(item) > 1;
            this.props.changeItemGender(item);
        } else {
            updatedServices.push(item);
        }

        this.props.setServices(updatedServices);
        if (clearQuantity) {
            this.props.changeItemQuantity(item);
        }
    }

    isItemSelected(item) {
        return (this.props.services || []).findIndex((service) => service.OnlineBookingServiceId === item.OnlineBookingServiceId) > -1;
    }

    priceSublabel = (item) => {
        if (!this.props.config || this.props.config.HideServicePrices) {
            return ''
        }

        let price;
        if (item.PriceFrom) {
            price = `${SHEKEL_SIGN}${item.PriceFrom}`
        }

        if (item.PriceTo && item.PriceTo !== item.PriceFrom) {
            price = `${SHEKEL_SIGN}${item.PriceTo} - ${price}`;
        }

        return price;
    };

    setExistingMeetingGroup(mode, group) {
        this.props.setExistingMeetingsGroupMode(mode, group);

        if (mode === 'modify') {
            setTimeout(() => {
                this.pickTime()
            }, 500);
        }
    }

    resolveItemQuantity = (item) => {
        let itemQuantity = (this.props.itemsQuantityMap[item.OnlineBookingServiceId] || '').split('_')[0]
        return isNonEmptyString(itemQuantity) ? parseInt(itemQuantity) : 1;
    }

    resolveSimultaneousType = (item) => {
        return (this.props.itemsQuantityMap[item.OnlineBookingServiceId] || '').split('_')[1]
    }

    resolveGender = (item) => {
        let genderMap = (this.props.itemsGenderMap[item.OnlineBookingServiceId] || '');
        return cleanObj(genderMap);
    }

    changeQuantity = (item, addition, simultaneousType = undefined) => {
        const currentQuantity = this.resolveItemQuantity(item);
        if (currentQuantity === 1 && !addition) {
            return this.toggleService(item);
        }


        if (addition && item.EnabledSimultaneousServicesCount <= currentQuantity) {
            return;
        }


        this.props.changeItemQuantity(item, addition, simultaneousType);
    }

    changeGender = (item, gendersMap) => {
        this.props.changeItemGender(item, gendersMap);
    }

    resolveSelectItemChild = (item) => {
        let toReturn = undefined;
        let pickGenderComponent;
        let subscriptionsAmountComponent;

        if (item.PickGenderCount > 0 && this.isItemSelected(item)) {
            const itemQuantity = this.resolveItemQuantity(item);
            pickGenderComponent = (
                <PickGender item={item} quantity={itemQuantity || 1}
                            onChange={(gendersMap) => this.changeGender(item, gendersMap)}
                            value={this.resolveGender(item)}
                            pickGenderMessage={this.props.config.PickGenderMessage}></PickGender>
            );
        }

        if (item.subscriptionRemaining) {

            subscriptionsAmountComponent = (
                <SubscriptionWrapperCmp className="subscription">
                    <Check fontSize="small"/>

                    <FormattedMessage id="subscriptionRemaining" values={{balance: item.subscriptionRemaining}}/>
                </SubscriptionWrapperCmp>
            )
        }

        if (item.SimultaneousServicesSchedulingType === SIMULTANEOUS_SERVICE_SCHEDULING_TYPE.BOTH && this.resolveItemQuantity(item) > 1) {
            let parallel = this.resolveSimultaneousType(item) !== SIMULTANEOUS_SERVICE_SCHEDULING_TYPE.WATERFALL;
            toReturn = (
                <SimultaneousServicesSchedulingType>
                    <SimultaneousServicesSchedulingTypePicker parallel={parallel}
                                                              onChange={(parallel) => this.changeQuantity(item, null, parallel ?
                                                                  SIMULTANEOUS_SERVICE_SCHEDULING_TYPE.PARALLEL
                                                                  : SIMULTANEOUS_SERVICE_SCHEDULING_TYPE.WATERFALL)}/>
                </SimultaneousServicesSchedulingType>
            )

            toReturn = (
                <div>
                    {toReturn}
                    <div style={{marginTop: Sizes.mediumPadding}}></div>
                    {subscriptionsAmountComponent}
                    {pickGenderComponent}
                </div>
            )
        } else if (item.PickGenderCount > 0 && this.isItemSelected(item)) {
            toReturn = pickGenderComponent;
        } else if (item.subscriptionRemaining) {
            toReturn = subscriptionsAmountComponent;
        }

        return toReturn;
    }

    resolveItemDescription = (item) => {
        if (!this.props.config.ShowServiceDescription || !isNonEmptyString(item.Description)) {
            return null;
        }

        return (<div style={{paddingLeft: Sizes.mediumPadding, paddingRight: Sizes.mediumPadding}}>
            {item.Description}
        </div>)
    }

    goNext(somePickGender) {
        if (somePickGender) {
            this.props.setServices(this.props.services);
        }

        this.next();
    }

    itemSupportsQuantity(item) {
        return item.EnabledSimultaneousServicesCount > 1;
    }


    render() {
        let pickMultipleServices = getSafely(['props', 'config', 'PickMultipleServices'], this, false);
        let somePickGender = getSafely(['props', 'config', 'PickGender'], this, false);
        let anySelectedServiceHasGenderOrQuantity = valueOrDefault(this.props.services, []).some((service) =>
            service.PickGenderCount > 0 || service.EnabledSimultaneousServicesCount > 1);
        let showNextButton = pickMultipleServices || (anySelectedServiceHasGenderOrQuantity);

        const ltr = !this.props.intl.locale.includes('he');
        const currentProgressIndex = valueOrDefault(this.props.progress, []).findIndex((p) => p.label === PROGRESS_KEY.SERVICE) || 0;
        const categories = getSafely(['props', 'config', 'ServiceCategories'], this);
        const splitCategories = getSafely(['props', 'config', 'ShowServiceCategories'], this);
        const selectedCategory = getSafely(['props', 'serviceCategory'], this, null);
        const toolbarLogo = getSafely(['theme', 'properties', 'avatarImage'], window) || (this.props.config && this.props.config.Logo) || '';

        return (
            <div className="transition-item detail-page detail-page__pick-services">
                <SelectViewWrapper padding={true} loading={!this.props.config} ltr={ltr}>
                    <ToolbarWithLogo imageUri={toolbarLogo} ltr={ltr}
                                     rootUri={this.getRoutePrefix()}>
                        <ProgressTracker progress={this.props.progress} current={currentProgressIndex}
                                         visible={true}/>
                    </ToolbarWithLogo>

                    <TopWrapper justify="start" align="start" padding={true} constantHeight={showNextButton}
                                preventFlex={true}>
                        <HH1><FormattedMessage id="schedule.pickAService"/></HH1>
                        {splitCategories && <CarouselWrapper>
                            <HorizontalCarousel items={categories} includeAll={true}
                                                selected={selectedCategory}
                                                onSelected={this.props.selectServiceCategory}/>
                        </CarouselWrapper>}

                        {this.state.didMount &&

                            <Select
                                ltr={ltr}
                                scrollToTop={true}
                                quantityResolver={this.resolveItemQuantity}
                                changeQuantity={this.changeQuantity}
                                preventPaddingBottom={showNextButton}
                                multiSelect={pickMultipleServices}
                                selected={this.props.services}
                                enableQuantitySelectionForItem={this.itemSupportsQuantity.bind(this)}
                                onClick={(service) => this.toggleService(service)}
                                items={this.props.filteredAvailableServices}
                                resolveItemDescription={this.resolveItemDescription.bind(this)}
                                keyProp="OnlineBookingServiceId"
                                subLabalProp={this.priceSublabel}
                                subLabelLeft={true}
                                resolveItemSecondLine={this.resolveSelectItemChild}
                                nameProp="ServiceRepresentativeName"/>
                        }

                    </TopWrapper>
                    <BottomWrapper empty={true}>
                        {showNextButton &&
                            <NavigationButton
                                disabled={this.props.loading || !this.props.services || this.props.services.length < 1}
                                click={() => this.goNext(somePickGender)}><FormattedMessage
                                id="schedule.next"/></NavigationButton>
                        }
                        <PoweredBy negativeMargin={true}/>
                    </BottomWrapper>
                </SelectViewWrapper>
                {this.state.delayed && <Toast ref={(toast) => this.toast = toast}/>}
                <ExistingMeetingPopOver config={this.props.config}
                                        existingMeetings={this.props.existingMeetings}
                                        allowAdditionalMeetings={this.props.allowAdditionalMeetings}
                                        hidden={!this.props.hasOtherMeetings}
                                        removeMeetings={(meetings, callback) => this.props.removeMeetings(meetings, callback)}
                                        setExistingMeetingsGroupMode={(mode, group) => this.setExistingMeetingGroup(mode, group)}/>

            </div>
        )
    }
}

/** Styled-Components **/

const HH1 = styled(H1)`
    z-index: 1;
    text-align: center;
    width: 100%;
    padding-top: 0;
`;

/** END OF Styled-Components **/

const mapStateToProps = state => {
    return {
        loading: state.schedule.fetchingServices || state.schedule.fetching,
        error: state.schedule.error || state.schedule.errorWithServices,
        config: state.schedule.configWithServices,
        services: state.schedule.services,
        filteredAvailableServices: state.schedule.filteredAvailableServices || getSafely(['schedule', 'config', 'Services'], state, []),
        progress: state.schedule.progress,
        hasOtherMeetings: state.schedule.hasOtherMeetings,
        allowAdditionalMeetings: state.schedule.allowAdditionalMeetings,
        existingMeetings: state.schedule.nextExistingMeetings,
        itemsQuantityMap: state.schedule.itemsQuantityMap,
        itemsGenderMap: state.schedule.itemsGenderMap,
        serviceCategory: state.schedule.serviceCategory,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setServices: (service) => dispatch(setServices(service)),
        removeMeetings: (meeting, callback) => dispatch(removeMeetings(meeting, callback)),
        setExistingMeetingsGroupMode: (mode, group) => dispatch(setExistingMeetingsGroupMode(mode, group)),
        changeItemQuantity: (item, addition, simultaneousType) => dispatch(changeItemQuantity(item, addition, simultaneousType)),
        changeItemGender: (item, genderMap) => dispatch(changeItemGender(item, genderMap)),
        selectServiceCategory: (item) => dispatch(selectServiceCategory(item)),
        resetWizard: () => dispatch(resetWizard())

    }
};


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PickServices));
